<template>
  <div class="nav-wrapper">
    <div class="logo">
      <img v-if="logoImage" :src="logoImage" alt="logo" height="50px" width="150px" style="margin:5px 20px 0 0">
      <!-- <div v-else style="font-size:26px;margin-right:50px" @click="$router.push('/home')">logo</div> -->
      <div class="nav-items">
        <div
            v-for="(item, i) in navList"
            :key="i"
            @click="toDetail(item, i)"
            :class="['nav-item', { 'active': $route.path === item.path }]"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="login" v-if="!hideLogin">
      <div v-if="!isLogin" class="btn">
        <div @click="login">登录</div>
        <!-- <div @click="login('add')">注册</div> -->
      </div>
      <div v-else class="loginOut">
        <el-dropdown trigger="hover">
          <div class="avatar-wrapper">
            <span class="el-icon-picture-outline-round" style="font-size: 35px;"/>
            <span style="font-size: 12px;margin-left:10px">{{ name }}</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="info">
              <span>后台管理</span>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {getFooterData, getAllPages} from "@/api";
import {navArray} from "@/config";

export default {
    name: 'Nav',
    data() {
        return {
            navList: [...navArray],
            hideLogin: true,
            isLogin: null,
            mobile: '',
            logoImage: null // 新增 logoImage 数据属性
        };
    },
    computed: {
        ...mapGetters(["avatar", "name", "roles", "isPay"]),
    },
    mounted() {
      this.fetchHomeData();
      this.fetchPageNav();
    },

    methods: {
      // 动态拉取图文页导航（原"关于我们/招商加盟"等已统一为后端图文页，按 sortOrder 返回）
      async fetchPageNav() {
        try {
          const response = await getAllPages();
          if (response && response.code === 0 && Array.isArray(response.data)) {
            const pageNav = response.data.map(page => ({
              name: page.pageName,
              path: `/page/${page.id}`
            }));
            this.navList = [...navArray, ...pageNav];
            // 缓存动态导航，后端临时不可用时兜底展示
            localStorage.setItem('pageNavList', JSON.stringify(pageNav));
          }
        } catch (error) {
          console.error('获取图文页导航失败:', error);
          // 后端不可用时，使用上次成功拉取的动态导航兜底
          try {
            const cached = localStorage.getItem('pageNavList');
            if (cached) {
              this.navList = [...navArray, ...JSON.parse(cached)];
            }
          } catch (e) {
            // 缓存解析失败时保持固定导航
          }
        }
      },
      async fetchHomeData() {
        try {
          this.isLogin = !!localStorage.getItem("token");
          const response = await getFooterData();
          if (response && response.data && response.data.length > 0) {
            let footerData = response.data[0];
            // 将数据缓存到localStorage
            localStorage.setItem('footerData', JSON.stringify(footerData));

            this.logoImage = footerData.logoImage;
            this.hideLogin = footerData.hideLogin;
            if(this.$parent.refreshHomeData){
              // 刷新父页面
              this.$parent.refreshHomeData();
            }
          }
          else {
            this.hideLogin = false;
          }
        } catch (error) {
          console.error('获取数据失败:', error);
        }
      },
      logout() {
          // 调后端登出接口吊销 token，并清除本地登录态
          this.$store.dispatch('user/logout').then(() => {
              this.$message.success('退出成功')
              this.isLogin = false
          })
      },
      login(e) {
          this.$router.push('/login')
      },
      info() {
          this.$router.push({
              path: '/info'
          })
      },
      toDetail(item, i) {
          this.$router.push({
              path: item.path
          })
      },
    },
};
</script>

<style lang="scss" scoped>
.nav-wrapper {
    width: 100%;
    height: 75px;
    z-index: 10000;
    max-width: 1300px;
    margin: 0 auto;
    padding: 0 15px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    //border-radius:0 0 20px 20px;
    background: #ffffff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    display: flex;
    justify-content: space-between; // 使用 space-between 来分配空间
    align-items: center; // 垂直居中对齐

    .logo {
      display: flex;
      align-items: center;
      flex: 1; // 让 logo 部分占据剩余空间

      .nav-items {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none;  /* Internet Explorer 10+ */

        &::-webkit-scrollbar {
          display: none; /* WebKit */
        }
    }
  }

  .nav-item {
        flex: 0 0 auto;
        padding: 0 15px;
        height: 72px;
        line-height: 72px;
        text-align: center;
        cursor: pointer;
        white-space: nowrap;
        transition: color 0.3s;

        &:hover, &.active {
          color: #4c88ff;
        }
      }

    .login {
      display: flex;
      align-items: center;


      .loginOut {
        line-height: 72px;

        .user-avatar {
          cursor: pointer;
          width: 20px;
          height: 20px;
          border-radius: 10px;
          margin: -5px 0 0 5px;
        }

        .avatar-wrapper {
          display: flex;
          align-items: center;
          height: 72px;
        }
      }

      .btn {
        display: flex;

        div {
          width: 50px;
          height: 72px;
          line-height: 72px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }

  .active {
    color: #0b2183;
    border-bottom: 3px solid #0b2183;
  }


  @media (max-width: 768px) {
  .container {
    width: 95%;
    flex-direction: column;
    align-items: flex-start;
  }

  .logo {
    width: 100%;
    margin-bottom: 10px;
  }

  .login {
    width: 100%;
    justify-content: flex-end;
  }
}
</style>
